// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 105) return "static/chunks/105.32622ea74b4ca17d.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"4596":"79a67388","6227":"bddf029b"}[chunkId] || chunkId) + "-" + {"4596":"1e7774c66dc7625d","6227":"2e7358d1060d4d95","8628":"a9b04bde6dabd339"}[chunkId] + ".js";
};